import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  CreateTraderSurveillanceProfileInput,
  SelectListItem,
  TraderSurveillanceProfileDto,
  TsProfileFilterDto,
} from '@/api/types/traderSurveillance';

// ABP conventional-controller mapping of AlertsProfileAppService. The CRUD-by-id methods
// use ABP's canonical names (Get/Create/Update/Delete) so they produce the standard CRUD
// routes (root for POST, /{id} for GET/PUT/DELETE) — the four same-named "Profile" actions
// previously collapsed and only POST resolved. Distinct-named GETs keep their kebab route.
//   GetPrioritiesAsync      -> GET    /priorities
//   GetActiveProfilesAsync  -> GET    /active-profiles
//   GetDeletedProfilesAsync -> GET    /deleted-profiles
//   GetAsync(id)            -> GET    /{id}
//   CreateAsync             -> POST   (root)
//   UpdateAsync(id)         -> PUT    /{id}
//   DeleteAsync(id)         -> DELETE /{id}
//   SetProfileEnabledAsync  -> POST   /set-profile-enabled/{id}?enabled=  (id arg → route path)
const BASE = '/api/app/alerts-profile';

export const alertsProfileApi = {
  getPriorities: () =>
    http.get<SelectListItem[]>(`${BASE}/priorities`).then((r) => r.data),

  getActiveProfiles: (input: TsProfileFilterDto) =>
    http.get<PagedResult<TraderSurveillanceProfileDto>>(`${BASE}/active-profiles`, { params: input }).then((r) => r.data),

  getDeletedProfiles: (input: TsProfileFilterDto) =>
    http.get<PagedResult<TraderSurveillanceProfileDto>>(`${BASE}/deleted-profiles`, { params: input }).then((r) => r.data),

  getProfile: (id: string) =>
    http.get<TraderSurveillanceProfileDto>(`${BASE}/${id}`).then((r) => r.data),

  createProfile: (input: CreateTraderSurveillanceProfileInput) =>
    http.post<TraderSurveillanceProfileDto>(BASE, input).then((r) => r.data),

  updateProfile: (id: string, input: CreateTraderSurveillanceProfileInput) =>
    http.put<TraderSurveillanceProfileDto>(`${BASE}/${id}`, input).then((r) => r.data),

  deleteProfile: (id: string) =>
    http.delete<void>(`${BASE}/${id}`).then((r) => r.data),

  setProfileEnabled: (id: string, enabled: boolean) =>
    http.post<void>(`${BASE}/set-profile-enabled/${id}`, null, { params: { enabled } }).then((r) => r.data),
};
